import { render, staticRenderFns } from "./BrbModal.vue?vue&type=template&id=0add7d5f&"
import script from "./BrbModal.vue?vue&type=script&lang=js&"
export * from "./BrbModal.vue?vue&type=script&lang=js&"
import style0 from "./BrbModal.vue?vue&type=style&index=0&id=0add7d5f&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0add7d5f')) {
      api.createRecord('0add7d5f', component.options)
    } else {
      api.reload('0add7d5f', component.options)
    }
    module.hot.accept("./BrbModal.vue?vue&type=template&id=0add7d5f&", function () {
      api.rerender('0add7d5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/BrbModal.vue"
export default component.exports